(() => {
  'use strict';
  const nativeRoot = () => window.Shopify?.routes?.root || '/';
  const language = document.querySelector('[data-mx10-language]');
  function languageDestination(code, current, alternates) {
    const hosts = ['mxprostoreparts.com', 'www.mxprostoreparts.com', 'road.mxprostoreparts.com'];
    if (!hosts.includes(current.hostname)) return null;
    const active = alternates.find(link => link.hreflang !== 'x-default' && new URL(link.href).pathname === current.pathname);
    const region = active?.hreflang.includes('-') ? active.hreflang.slice(active.hreflang.indexOf('-')) : '';
    const target = alternates.find(link => link.hreflang === code + region) || alternates.find(link => link.hreflang === code);
    if (!target) return null;
    const destination = new URL(target.href);
    if (destination.protocol !== 'https:' || !hosts.includes(destination.hostname)) return null;
    destination.hostname = current.hostname;
    destination.search = current.search;
    destination.hash = current.hash;
    return destination.href;
  }
  language?.addEventListener('change', () => {
    const destination = languageDestination(language.value, location, [...document.querySelectorAll('link[rel="alternate"][hreflang]')]);
    const error = document.querySelector('[data-mx10-language-error]');
    if (destination) { location.assign(destination); return; }
    language.value = document.documentElement.lang.split('-')[0];
    if (error) error.hidden = false;
  });
  const garageLabel = document.querySelector('[data-mx10-garage]');
  const emptyGarageLabel = garageLabel?.textContent || '';
  function restoreGarage() {
    const world = document.querySelector('[data-mx10-world]')?.dataset.mx10World === 'road' ? 'road' : 'cross';
    if (garageLabel) garageLabel.textContent = emptyGarageLabel;
    try {
      const value = JSON.parse(localStorage.getItem('mxpro-next-garage-' + world));
      if (value && typeof value.make === 'string' && typeof value.model === 'string' && Number.isInteger(value.year)) {
        const label = document.querySelector('[data-mx10-garage]');
        if (label) label.textContent = `${value.make} ${value.model} · ${value.year}`;
      }
      const motor = document.querySelector('[data-mx10-motor]');
      const cross = JSON.parse(localStorage.getItem('mxpro-next-garage-cross'));
      if (motor && !motor.value && cross?.segment === 'cross' && typeof cross.make === 'string' && typeof cross.model === 'string' && Number.isInteger(cross.year)) motor.value = `${cross.make} ${cross.model} ${cross.year}`;
    } catch {}
  }
  restoreGarage();
  document.addEventListener('mxpro:vehicle-change', restoreGarage);
  window.addEventListener('storage', restoreGarage);
  const workshop = document.querySelector('.mx10-workshop-form');
  if (workshop) {
    const review = workshop.querySelector('[data-mx10-review]');
    const send = workshop.querySelector('[data-mx10-send]');
    const summary = workshop.querySelector('[data-mx10-summary]');
    const date = workshop.querySelector('[data-mx10-date]');
    if (date) {
      const today = new Date();
      date.min = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }
    if (review && send && summary) {
      review.hidden = false;
      send.hidden = true;
      let reviewed = false;
      function hideReview() { reviewed = false; summary.hidden = true; review.hidden = false; }
      workshop.addEventListener('input', hideReview);
      workshop.addEventListener('change', hideReview);
      function showReview() {
        if (!workshop.reportValidity()) return;
        const list = summary.querySelector('dl');
        list.replaceChildren();
        for (const input of workshop.querySelectorAll('input:not([type=hidden]):not([type=checkbox]), select, textarea')) {
          const label = workshop.querySelector(`label[for="${input.id}"]`);
          if (!label) continue;
          const term = document.createElement('dt');
          term.textContent = label.textContent;
          const detail = document.createElement('dd');
          detail.textContent = input.value || '—';
          list.append(term, detail);
        }
        reviewed = true;
        summary.hidden = false;
        review.hidden = true;
        summary.scrollIntoView({block: 'center', behavior: 'smooth'});
      }
      review.addEventListener('click', showReview);
      workshop.querySelector('[data-mx10-edit]')?.addEventListener('click', () => { hideReview(); workshop.querySelector('input:not([type=hidden])')?.focus(); });
      workshop.addEventListener('submit', event => {
        if (!reviewed) { event.preventDefault(); showReview(); }
      });
    }
    const success = workshop.querySelector('[data-mx10-contact-success]');
    if (success) { success.focus(); success.scrollIntoView({block: 'center'}); }
  }
  if (!customElements.get('mxpro-bok-offer')) customElements.define('mxpro-bok-offer', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form')?.addEventListener('submit', event => this.add(event));
    }
    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      const form = event.currentTarget;
      if (!form.reportValidity()) return;
      this.busy = true;
      const button = form.querySelector('[type=submit]');
      const error = this.querySelector('[data-mx10-bok-error]');
      const original = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.busy;
      error.hidden = true;
      const pageItems = document.getElementById('main-cart-items');
      const pageFooter = document.getElementById('main-cart-footer');
      const drawer = document.querySelector('cart-drawer');
      const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      if (pageItems?.dataset.id) sectionIds.push(pageItems.dataset.id);
      if (pageFooter?.dataset.id) sectionIds.push(pageFooter.dataset.id);
      const body = new FormData(form);
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', location.pathname);
      let declined = '';
      try {
        const response = await fetch(nativeRoot() + 'cart/add.js', {method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body});
        const result = await response.json();
        if (!response.ok || result.status) {
          declined = typeof result.description === 'string' ? result.description : this.dataset.error;
          throw new Error(declined);
        }
        const validSections = sectionIds.every(id => typeof result.sections?.[id] === 'string' && result.sections[id]);
        if (!validSections) { location.assign(window.routes?.cart_url || nativeRoot() + 'cart'); return; }
        if (pageItems && pageFooter) {
          for (const section of [pageItems, pageFooter]) {
            const id = section.dataset.id;
            const wrapper = document.getElementById('shopify-section-' + id);
            const parsed = new DOMParser().parseFromString(result.sections[id], 'text/html');
            const fresh = parsed.getElementById('shopify-section-' + id);
            if (!wrapper || !fresh) { location.assign(window.routes?.cart_url || nativeRoot() + 'cart'); return; }
            wrapper.replaceChildren(...fresh.childNodes);
          }
          const icon = document.getElementById('cart-icon-bubble');
          const markup = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (icon && markup) icon.replaceChildren(...markup.childNodes);
        } else if (drawer?.renderContents) {
          drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
          drawer.renderContents(result);
        } else location.assign(window.routes?.cart_url || nativeRoot() + 'cart');
        for (const offer of document.querySelectorAll('mxpro-bok-offer')) offer.hidden = true;
      } catch (failure) {
        error.textContent = declined || this.dataset.error;
        error.hidden = false;
      } finally {
        this.busy = false;
        if (button.isConnected) { button.disabled = false; button.textContent = original; }
      }
    }
  });
})();
